import { fetchAPI } from "@/api/api"
import { QueryInItInfoResponse } from "@/types/queryInitInfo"

const QUERY_INIT_INFO = "/exchange/member/playerService/queryInitInfo"

const fetch = {
  url: QUERY_INIT_INFO,
  handler: async () => {
    try {
      const res: QueryInItInfoResponse = await fetchAPI({
        url: QUERY_INIT_INFO,
        method: "post",
        withCredentials: true,
        pageName: ""
      })

      return Promise.resolve(res)
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default fetch
